var $ = jQuery.noConflict();

$(document).ready(function() {
   /*** Header fixed ***/
    $(window).scroll(function() {
        var scrollPixel = $(window).scrollTop();
        var topHeight = $(".header-top").outerHeight();
        if (scrollPixel < 70) {
            $("header").removeClass("scroll-fix");
            $(".header-top").css("margin-top", 0);
        } else {
            $("header").addClass("scroll-fix");
            $(".header-top").css("margin-top", -topHeight);
        }
    }); 

    headerResize();

    /*** Script for SVG to code ***/
    $(function() {
        jQuery("img.svg").each(function() {
            var $img = jQuery(this);
            var imgID = $img.attr("id");
            var imgClass = $img.attr("class");
            var imgURL = $img.attr("src");

            jQuery.get(imgURL, function(data) {
                var $svg = jQuery(data).find("svg");
                if (typeof imgID !== "undefined") {
                    $svg = $svg.attr("id", imgID);
                }
                if (typeof imgClass !== "undefined") {
                    $svg = $svg.attr("class", imgClass + " replaced-svg");
                }
                $svg = $svg.removeAttr("xmlns:a");

                if (!$svg.attr("viewBox") &&
                    $svg.attr("height") &&
                    $svg.attr("width")
                ) {
                    $svg.attr(
                        "viewBox",
                        "0 0 " + $svg.attr("height") + " " + $svg.attr("width")
                    );
                }
                $img.replaceWith($svg);
            }, "xml");
        });
    });   
    $(".cmn-select-box").select2({
        minimumResultsForSearch: Infinity,
        dropdownAutoWidth: true,
        width: "100%"
      });
});

/*** Mobile Header toggle ***/
function headerResize() {
    var screenWidth = $(window).width();
    if (screenWidth <= 991.98) {
        $(".navbar-toggler").off("click");
        $(".navbar-toggler").on("click", function() {
            $("header").toggleClass("navbar-show");
        }); 
    } else {
        $("header nav").removeClass("navbar-show");
        $(".navbar-toggler").attr("aria-expanded", "false");
    }
}

$(window).resize(function() {
    headerResize();
});
